import tw, { css, styled } from 'twin.macro'

export const HeroSection = styled.section`
	background-image: url(${({ sources }) => sources[0].base64});
	${tw`bg-cover bg-center bg-no-repeat`}
	min-height: 600px;
`
export const HeroContainer = styled.div`
  ${tw`bg-cover bg-center bg-no-repeat py-8 flex items-center flex-col justify-center`}
  background-image: url(${({ sources }) =>
		sources ? sources[0].srcWebp : ''});
  background-image: url(${({ sources }) => (sources ? sources[0].src : '')});
  min-height: 600px;
`
export const HeroDetails = tw.div`w-10/12 mx-auto flex flex-col items-center justify-center`

export const Title = styled.h1`
	@media (min-width: 525px) {
		${tw`text-6xl`}
	}
	${tw`mb-8 font-display text-5xl md:text-7xl font-bold text-white`}
`
export const TitleSubText = tw.h3`mb-8 font-display text-xl font-bold text-white text-center`
export const Paragraph = tw.p`mb-8 text-center leading-normal text-lg font-display text-white`

export const ToggleButtonSection = styled.section`
	@media (min-width: 525px) {
		${tw`w-10/12`}
	}
	${tw`flex flex-col md:flex-row pt-12 md:pt-24 md:w-10/12 lg:w-9/12 xxxl:w-7/12 m-auto items-center`}
`
export const Button = styled.a`
	@media (min-width: 525px) {
		${tw`w-6/12`}
	}
	${tw`md:w-4/12 flex font-display justify-center mb-8 md:mb-0`}

	> p {
		${tw`relative border-gray-400 py-16 text-center cursor-pointer font-display font-bold flex items-center justify-center`}
		border-width: 10px;
		border-radius: 100%;
		width: 190px;
		height: 190px;

		@media (min-width: 768px) and (max-width: 1279px) {
			width: 150px;
			height: 150px;
		}

		@media (min-width: 375px) and (max-width: 767px) {
			width: 150px;
			height: 120px;
		}

		&:before {
			content: '';
			${tw`border-white absolute`}
			border-width: 10px;
			top: -20px;
			left: -20px;
			right: -20px;
			bottom: -20px;
			border-radius: 100%;
		}

		.active&:after {
			content: '';
			${tw`border-blue-500 border-8 absolute`}
			top: -28px;
			left: -28px;
			right: -28px;
			bottom: -28px;
			border-radius: 100%;
		}
	}
`

export const BtnDetailsSection = tw.section`w-full pt-12 md:py-24`
export const BtnDetailsContainer = tw.div`w-full flex flex-col`
export const NullText = tw.p`font-display text-dolphin-gray text-2xl bg-white p-8 w-full text-center`
export const Bold = tw.b`font-bold block mb-2`
export const DetailTitle = styled.h2`
	@media (min-width: 525px) {
		${tw`text-5xl`}
	}
	${tw`font-display text-4xl md:text-6xl xl:text-7xl text-blue-500 text-center font-bold mb-10 px-4`}
`
export const DetailText = styled.p`
	@media (min-width: 525px) {
		${tw`text-xl`}
	}
	${tw`text-center font-display text-lg px-4`}
`
export const UnorderedList = styled.ul`
	${tw`flex flex-col mt-24 mb-40`}

	> li {
		${tw`w-full flex flex-row`}

		> p {
			${tw`relative w-6/12 py-6 font-display text-base md:text-lg`}

			b {
				${tw`text-xl text-blue-600`}
			}
		}
	}
	> li:nth-of-type(2n + 2) {
		${tw`justify-end`}

		> p {
			@media (min-width: 525px) {
				${tw`pl-20 pr-4`}
			}
			${tw`relative text-left pl-10 pr-2 md:pl-24 md:pr-4 lg:px-24 xl:px-48`}

			&:before {
				content: '';
				${tw`border-l-4 border-gray-500 border-r-0 absolute top-0 bottom-0`}
				left: -2px;
			}

			&:after {
				content: '';
				${tw`absolute bg-dolphin-gray`}
				width: 20px;
				height: 20px;
				border-radius: 100%;
				top: 25px;
				left: -10px;
			}

			b {
				&:before {

					@media (min-width: 525px) {
						${tw`w-8`}
					}
					${tw`border-t-2 border-dolphin-gray absolute w-2 md:w-12 lg:w-12 xl:w-32 right-0`}
					top: 35px;
					left: 30px;

					@media (min-width: 375px) and (max-width: 524px) {
						left: 20px;
					}
				}
			}
		}
	}

	> li:nth-of-type(2n + 3) {
		> p {
			@media (min-width: 525px) {
				${tw`pr-20 pl-4`}
			}
			${tw`relative text-right pr-10 pl-2 md:pr-24 md:pl-4 lg:px-24 xl:px-48`}

			&:after {
				content: '';
				${tw`border-r-4 border-gray-500 border-l-0 absolute top-0 bottom-0`}
				right: -2.1px;
			}

			b {
				&:before {
					@media (min-width: 525px) {
						${tw`w-8`}
					}
					${tw`border-t-2 border-dolphin-gray absolute w-2 md:w-12 lg:w-12 xl:w-32`}
					top: 35px;
					right: 30px;

					@media (min-width: 375px) and (max-width: 524px) {
						right: 20px;
					}
				}
			}

			&:before {
				content: '';
				${tw`absolute bg-dolphin-gray`}
				width: 20px;
				height: 20px;
				border-radius: 100%;
				top: 25px;
				right: -10px;
				z-index: 1;
			}
		}
	}

	> li:first-of-type {
		> p {
			${tw`m-auto px-0 flex items-center justify-center text-center text-xl md:text-2xl uppercase text-white font-bold`}
			width: 150px;
			height: 150px;
			border-radius: 100%;
			background: #66b8d0; /* Old browsers */
			background: -moz-linear-gradient(
				left,
				#1b7db3 0%,
				#2e8fb1 50%,
				#65c0d8 100%
			); /* FF3.6-15 */
			background: -webkit-linear-gradient(
				left,
				#1b7db3 0%,
				#2e8fb1 50%,
				#65c0d8 100%
			); /* Chrome10-25,Safari5.1-6 */
			background: linear-gradient(
				to left,
				#1b7db3 0%,
				#2e8fb1 50%,
				#65c0d8 100%
			);

			@media (min-width: 375px) and (max-width: 767px) {
				width: 120px;
				height: 120px;
			}
		}
	}

	> li:last-of-type p {
		${tw`uppercase font-bold text-xl w-full text-center`}
		&:before {
			display: none;
		}
		&:after {
			display: none;
		}
	}
`

export const ValuesImage = tw.img`m-auto mt-4 md:mt-16 mb-6 md:mb-20 md:w-11/12 lg:w-8/12 xl:w-auto`
export const ValuesContainer = styled.div`
	@media (min-width: 525px) {
		${tw`flex-row`}
	}
	${tw`flex lg:w-11/12 xl:w-10/12 xxl:w-9/12 xxxl:w-8/12 mx-auto mt-0 md:-mt-12 items-start mb-20 md:mb-32 lg:mb-48 flex-wrap md:flex-nowrap`}

	/* > div:first-of-type,
    > div:last-of-type {
		${tw`md:-mt-48 lg:-mt-48 xl:-mt-64`}
	}

	> div:nth-of-type(2),
	> div:nth-last-of-type(2) {
		${tw`md:-mt-20 lg:-mt-16 xl:-mt-32`}
	} */
`
export const Value = styled.div`
	@media (min-width: 525px) {
		${tw`w-4/12`}
	}
	${tw`w-6/12 md:w-1/6 flex flex-col p-2 md:px-0`}
`
export const ValueImg = tw.div`w-8/12 m-auto mb-4`
export const ValueText = tw.p`lg:text-lg xl:text-2xl font-bold font-display text-center md:px-2 lg:px-6`
export const ValuesTitle = styled(DetailTitle)``

export const MissionContainer = tw.div`mb-20`
export const MissionTitle = styled(DetailTitle)``
export const MissionText = tw.p`text-center font-display text-xl xxxl:w-8/12 mx-auto mb-4 px-4`
